import dayjs from 'dayjs';

/**
 * 判断时间差
 */
export default function diffTime(time: dayjs.ConfigType): Object {
  let d = dayjs(time);
  const now = dayjs();

  if (d.isAfter(now)) {
    d = now;
  }

  const day = 864e5;
  const month = 30 * day;
  const diff = now.diff(d);
  const curMonth = d.month() === now.month();
  let dayDiff: boolean = false;
  let monthDiff: boolean = false;

  if (diff >= day && diff <= month && curMonth) {
    monthDiff = true;
  } else if (diff < day) {
    dayDiff = true;
  }

  return {dayDiff, monthDiff};

}
